/**
 * <SubscriptionNextStepCardSkeleton> — la forme de la carte « Et ensuite ? » pendant un chargement.
 *
 * Le cas le plus courant, celui d'une suite à activer : la chip d'état, l'accroche et la ligne de
 * l'offre, le prix et ses lignes de détail, les garanties (un glyphe, une ligne), puis les deux
 * gestes — deux tiers « Activer la suite », un tiers « Modifier », comme la carte. Le liseré de gauche est gardé, dans
 * la couleur des blocs : sa couleur dit un état que la page ne connaît pas encore.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { pushButtonBoxHeight } from "../../atoms/Buttons/Button/Button"
import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { Skeleton } from "../../atoms/Skeleton"
import { Card } from "../../molecules/Card"

/** Les trois garanties d'une suite engagée : modifiable, pause, annulable. */
const GUARANTEE_WIDTHS = [260, 150, 170]

/** Les deux gestes sont des boutons `md` : leur face et leur relief. */
const BUTTON_HEIGHT = pushButtonBoxHeight("md")

export function SubscriptionNextStepCardSkeleton() {
    return (
        <Card p="4" leftBorderColor="initials-fill">
            <Stack gap="3">
                <Row>
                    <Skeleton shape="chip" width={100} />
                </Row>
                <Stack gap="1">
                    <Skeleton textSize="text-xl" width={240} />
                    <Skeleton textSize="text-md" width={150} />
                </Stack>
                <Stack gap="1">
                    <Skeleton textSize="text-xl" width={200} />
                    <Skeleton textSize="text-sm" width={210} />
                    <Skeleton textSize="text-sm" width={150} />
                </Stack>
                <Stack gap="2">
                    {GUARANTEE_WIDTHS.map((width) => (
                        <Row key={width} gap="2" align="center">
                            <Skeleton shape="circle" size={16} />
                            <Skeleton textSize="text-md" width={width} />
                        </Row>
                    ))}
                </Stack>
                <Row gap="2">
                    <Skeleton shape="block" width="auto" height={BUTTON_HEIGHT} style={styles.primaryAction} />
                    <Skeleton shape="block" width="auto" height={BUTTON_HEIGHT} style={styles.secondaryAction} />
                </Row>
            </Stack>
        </Card>
    )
}

/** Les parts des deux gestes de la carte : deux tiers, un tiers. */
const styles = StyleSheet.create(() => ({
    primaryAction: { flex: 2 },
    secondaryAction: { flex: 1 },
}))
